import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { getRefundEnrolments } from '../../services/courseEnrolmentService';
import { formatRefundCSVData } from '../../utilities/formatData';
import RefundsSearch from './components/RefundsSearch';
import RefundsTable from './components/RefundsTable';
const Refund = () => {
  const [refundedEnrolments, setRefundedEnrolments] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((pageNo - 1) * pageSize);
  const [refundValue, setRefundValue] = useState(0);
  const [fetching, setFetching] = useState(false);
  const [searchFilter, setSearchFilters] = useState({});
  const [csvReport, setCsvReport] = useState({});

  useEffect(() => {
    fetchRefundEnrolments();
  }, [pageNo, pageSize, searchFilter]);

  useEffect(() => {
    fetchCSVData();
  }, [searchFilter]);

  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
    setSearchFilters({});
    setOffset(0);
    setPageNo(1);
    setRefundValue(0);
    fetchCSVData();
  };
  const onFinish = (values) => {
    setPageNo(1);
    setSearchFilters(values);
  };

  const fetchCSVData = () => {
    const formatted = {
      startDate: searchFilter?.startDate,
      endDate: searchFilter?.endDate
    };
    if (searchFilter?.isPartial !== 'All') {
      formatted.isPartial = searchFilter?.isPartial;
    }

    if (formatted.startDate)
      formatted.startDate = formatted.startDate.format('YYYY-MM-DD');
    if (formatted.endDate)
      formatted.endDate = formatted.endDate.format('YYYY-MM-DD');
    getRefundEnrolments({}, formatted)
      .then((response) => {
        const data = response.data.data;
        setCsvReport(formatRefundCSVData(data));
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const fetchRefundEnrolments = () => {
    const formatted = {
      startDate: searchFilter?.startDate,
      endDate: searchFilter?.endDate
    };
    if (searchFilter?.isPartial !== 'All') {
      formatted.isPartial = searchFilter?.isPartial;
    }

    if (formatted.startDate)
      formatted.startDate = formatted.startDate.format('YYYY-MM-DD');
    if (formatted.endDate)
      formatted.endDate = formatted.endDate.format('YYYY-MM-DD');
    setFetching(false);
    const paginationParams = { paginate: 1, pageNo, pageSize };
    getRefundEnrolments(paginationParams, formatted)
      .then((response) => {
        const data = response.data.data;
        setRefundValue(data?.totalRefund);
        setFetching(false);
        setTotalCount(data?.totalCount);
        setRefundedEnrolments(data.paginatedList);
      })
      .catch((error) => {
        setFetching(false);
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const onPaginationChange = (data) => {
    setPageNo(data.current);
    setPageSize(data.pageSize);
    setOffset(data.current * data.pageSize - data.pageSize);
  };

  return (
    <div>
      <div>
        <section>
          <RefundsSearch
            onFinish={onFinish}
            onReset={onReset}></RefundsSearch>
        </section>
      </div>
      <div>
        <section>
          <h1>Refund Value: {refundValue} USD</h1>
        </section>
        <section>
          {csvReport.data && csvReport.data.length > 0 ? (
            <CSVLink
              data={csvReport.data}
              headers={csvReport.headers}
              filename={csvReport.filename}>
              Export to CSV
            </CSVLink>
          ) : null}
        </section>
        <br /> <br /> <br />
        <section>
          <RefundsTable
            data={refundedEnrolments}
            onPaginationChange={onPaginationChange}
            current={pageNo}
            totalCount={totalCount}
            fetching={fetching}
            offset={offset}
          />
        </section>
      </div>
    </div>
  );
};

export default Refund;
